<template>
  <div
    v-if="isImg"
    class="dh-psy-illustration"
    aria-hidden
    data-object-fit="contain"
  >
    <img
      :src="id"
      alt=""
    />
  </div>
  <div
    v-else
    class="dh-psy-illustration"
    aria-hidden
    v-html="illustration"
  />

</template>

<script>
const ILLUSTRATIONS = {
  'inne-ute': () => import('./Illustration/inne-ute.js'),
  'i-ko': () => import('./Illustration/i-ko.js'),
  'inne-ute--done': () => import('./Illustration/inne-ute--done.js'),
  risikovurdering: () => import('./Illustration/risikovurdering.js')
}

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      illustration: ''
    }
  },
  computed: {
    isImg() {
      return /.(png|jpg|jpeg|svg)/.test(this.id)
    }
  },
  mounted() {
    if (this.isImg && ILLUSTRATIONS[this.id]) {
      ILLUSTRATIONS[this.id]().then(illustration => {
        this.illustration = illustration.default
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
  .dh-psy-illustration {
    height: 100%;
    width: 100%;

    & :global(svg),
    & :global(img) {
      width: 100%;
      height: 100%;
      max-width: 750px;
      object-fit: contain;
    }
  }
</style>
